module.exports = __webpack_public_path__ + "static/media/Another Green World.5e7ddac6.jpg";